import { placeNewAgent } from '@/entities/queue-placement';
export async function placeNewAgentAction(input) {
    await placeNewAgent(input);
}
